import React, { useEffect, useState } from 'react';
import { Popup, Button, List, Ellipsis } from 'antd-mobile';
import styled from 'styled-components';

const PopupContent = styled(List)`
	padding: 12px;
	margin-top: 12px;

	.adm-list-body {
		border-top: none;
	}
`;

function AddToolPopup(props) {
	const {
		selectedItem,
		visible,
		initialValue,
		onClose,
		onSave,
		onDelete,
		loading,
		isAdd
	} = props;
	const [value, setValue] = useState(initialValue || 0);

	function getUsedIn(tool) {
		if (tool.work_order_op_id) {
			return tool.work_order_op_title || '-';
		}

		if (tool.defect) {
			return tool.defect_title || '-';
		}

		return null;
	}

	useEffect(() => {
		setValue(initialValue || 1);
	}, [selectedItem, visible, initialValue]);

	function onSaveClick() {
		onSave({
			id: selectedItem.id,
			amount_used: value
		});
	}

	return (
		<Popup
			visible={visible}
			showCloseButton={true}
			onClose={onClose}
			onMaskClick={onClose}
			bodyStyle={{
				borderTopLeftRadius: '8px',
				borderTopRightRadius: '8px',
				minHeight: '20vh'
			}}
		>
			<PopupContent>
				<List.Item
					key={selectedItem.id}
					clickable={false}
					title={selectedItem.name || selectedItem.part_nr || selectedItem.serial }
					description={isAdd ?
						`${selectedItem.issued_to ? `Issued to: ${selectedItem.issued_to_name}` : ''}` :
						<Ellipsis direction='end' rows={1} content={`${getUsedIn(selectedItem) ? `Used in: ${getUsedIn(selectedItem)}` : ''}`} />
					}
				>
					{selectedItem.marking || '-'}
				</List.Item>
				{isAdd ? <Button
					style={{ marginTop: 12 }}
					onClick={onSaveClick}
					color="success"
					loading={loading}
					block
				>
					{isAdd ? 'Add' : 'Save'}
				</Button> : <Button
					style={{ marginTop: 12 }}
					onClick={() => onDelete(selectedItem.id)}
					color="danger"
					loading={loading}
					block
				>
					Remove
				</Button>}
			</PopupContent>
		</Popup>
	);
}

export default AddToolPopup;
